const homeMessages = {
  en: {
    home: "Home",
    mynameis: "I'm Michał Jaskulski",
    fullstack: "Fullstack React Developer",
    fullstackMJ: "Michał Jaskulski ",
    management: "Effective management of the IT department",
    hometext:
      "I am a database application programmer and a manager combining technical skills with the ability to manage the IT Department.{br} Personally I will be happy to share the experience I have gained in many companies. {br} I am open to new chalenges and always ready to learn new technologies.",
    technologies: "Technologies used:",
    infomain: "Creating comprehensive IT solutions",
    slogan: "Innovative database solutions for your business",
  },
  pl: {
    home: "Start",
    mynameis: "Nazywam się Michał Jaskulski",
    fullstack: "Fullstack React Developer ",
    fullstackMJ: "Michał Jaskulski ",
    management: "Zarządzanie zasobami IT",
    hometext:
      "Jestem specjalistą w tworzeniu bezpiecznych aplikacji internetowych, opartych na rozwiązaniach chmurowych oraz wirtualnych serwerach VPS. {br}Łączę wiedzę programistyczną z doświadczeniem menedżerskim, co pozwala mi skutecznie realizować projekty zarówno od strony technicznej, jak i organizacyjnej. Od lat projektuję i rozwijam aplikacje bazodanowe oraz kompleksowo konfiguruję serwery VPS, dbając o ich bezpieczeństwo, wydajność i niezawodność. {br}Zajmuję się m.in.:{br}konfiguracją serwerów pocztowych i HTTPS,{br}wdrażaniem zabezpieczeń (firewall, certyfikaty SSL, backupy),{br}optymalizacją środowisk produkcyjnych.{br}W pracy stawiam na niezawodność, bezpieczeństwo oraz przejrzystość rozwiązań.{br}Chętnie dzielę się swoją wiedzą i doświadczeniem zdobytym podczas współpracy z firmami z różnych branż.{br}Jestem otwarty na nowe wyzwania i z entuzjazmem podchodzę do poznawania nowoczesnych technologii, które realnie wspierają rozwój biznesu.",
    technologies: "Wykorzystywane technologie:",
    infomain: "Kompleksowe rozwiązania - od pomysłu po wdrożenie.",
    slogan: "Innowacyjne rozwiązania bazodanowe dla Twojego biznesu",
  },
};
export default homeMessages;
